// Resolução de flags de configuração da empresa.
//
// As flags de recurso estão migrando de `planContract` (plano, editado no
// painel interno) para `configRules` (regras da empresa, editadas no admin).
// Enquanto as duas fontes coexistem, a leitura segue a precedência:
//   configRules -> planContract -> default.
// Mesma regra do mobile (`mobileNextJs/src/util/companyConfig.ts`).

// Valor gravado pode vir como string ("true"/"false") de telas antigas que
// salvavam o value do <select> direto. O menu lateral testa `=== false`, então
// uma string escaparia do gate — normaliza para booleano.
function toBool(value) {
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
}

export function resolveCompanyFlag(configRules, planContract, key, fallback) {
  const fromRules = toBool(configRules?.[key]);
  if (fromRules !== undefined && fromRules !== null) return fromRules;

  const fromPlan = toBool(planContract?.[key]);
  if (fromPlan !== undefined && fromPlan !== null) return fromPlan;

  return fallback;
}

// Cashback é o caso em que as duas fontes usam nomes diferentes:
// `configRules.cashback` (admin) e `planContract.showCashback` (painel).
export function resolveShowCashback(configRules, planContract, fallback = false) {
  const fromRules = toBool(configRules?.cashback);
  if (fromRules !== undefined && fromRules !== null) return fromRules;

  const fromPlan = toBool(planContract?.showCashback);
  if (fromPlan !== undefined && fromPlan !== null) return fromPlan;

  return fallback;
}
